import { SideModalCMTabType } from "DataTypes/Modal";

export const TabArr: SideModalCMTabType[] = [
  {
    id: "enroll-pdf",
    label: "Consent Form",
    stage: 1,
    prgmArr: ["CCM", "PCM", "GCM", "BHI", "RPM", "APCM"],
  },
  {
    id: "discharge-summary",
    label: "Discharge Summary",
    stage: 1,
    prgmArr: ["TCM"],
  },
  {
    id: "rpm-device",
    label: "Devices",
    stage: 5,
    prgmArr: ["RPM"],
  },
  {
    id: "care-team",
    label: "Care Team",
    stage: 6,
    prgmArr: ["CCM", "PCM", "GCM", "BHI", "APCM"],
  },
  {
    id: "rpm-team",
    label: "Care Team",
    stage: 6,
    prgmArr: ["RPM"],
  },
  {
    id: "tcm-team",
    label: "TCM Team",
    stage: 6,
    prgmArr: ["TCM"],
  },
  {
    id: "care-plan",
    label: "Care Plan",
    stage: 10,
    prgmArr: ["CCM", "PCM", "GCM", "BHI", "APCM"],
  },
  {
    id: "treatment-plan",
    label: "Treatment Plan",
    stage: 10,
    prgmArr: ["RPM"],
  },
  {
    id: "tcm",
    label: "TCM",
    stage: 10,
    prgmArr: ["TCM"],
  },
  {
    id: "care-plan-pdf",
    label: "Care Plan Pdf",
    stage: 10,
    prgmArr: ["CCM", "PCM", "GCM", "BHI", "APCM"],
  },
  {
    id: "tcm-plan-pdf",
    label: "TCM Pdf",
    stage: 10,
    prgmArr: ["TCM"],
  },
  {
    id: "treatment-plan-pdf",
    label: "Treatment Plan Pdf",
    stage: 10,
    prgmArr: ["RPM"],
  },
  {
    id: "previous-care-plans",
    label: "Previous Care Plans",
    stage: 10,
    prgmArr: ["APCM"],
  },
  {
    id: "previous-treatment-plans",
    label: "Previous Treatment Plans",
    stage: 10,
    prgmArr: ["RPM"],
  },
  {
    id: "previous-notes",
    label: "Previous Notes",
    stage: 10,
    prgmArr: ["CCM", "PCM", "GCM", "BHI", "RPM", "APCM"],
  },
  {
    id: "add-time-log",
    label: "Additional Time Logged",
    stage: 1,
    prgmArr: ["CCM", "PCM", "TCM", "GCM", "BHI", "RPM", "APCM"],
  },
  {
    id: "training-notes",
    label: "Training Notes",
    stage: 10,
    prgmArr: ["RPM"],
  },
];

export const unenrollObj: SideModalCMTabType = {
  id: "unenroll-pdf",
  label: "Cancellation Form",
  stage: 0,
  prgmArr: ["CCM", "PCM", "GCM", "BHI", "RPM", "APCM"],
};
